import { render, staticRenderFns } from "./ExpandableItemContrats.vue?vue&type=template&id=f8345504&scoped=true"
import script from "./ExpandableItemContrats.vue?vue&type=script&lang=js"
export * from "./ExpandableItemContrats.vue?vue&type=script&lang=js"
import style0 from "./ExpandableItemContrats.vue?vue&type=style&index=0&id=f8345504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8345504",
  null
  
)

export default component.exports